/**
 * Application geometry options for js/less.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

// public
module.exports = {
    480: {
        // screen base dimension
        height: 480,
        width: 720,
        // safe zone margins
        availTop: 24,
        availBottom: 24,
        availRight: 62,
        availLeft: 62,
        // project-specific vars
        listSize: 4,
        listSmallSize: 2
    },

    576: {
        // screen base dimension
        height: 576,
        width: 720,
        // safe zone margins
        availTop: 24,
        availBottom: 24,
        availRight: 62,
        availLeft: 62,
        // project-specific vars
        listSize: 4,
        listSmallSize: 2
    },

    720: {
        // screen base dimension
        height: 720,
        width: 1280,
        // safe zone margins
        availTop: 28,
        availBottom: 28,
        availRight: 66,
        availLeft: 66,
        // project-specific vars
        listSize: 6,
        listSmallSize: 5
    },

    1080: {
        // screen base dimension
        height: 1080,
        width: 1920,
        // safe zone margins
        availTop: 42,
        availBottom: 42,
        availRight: 75,
        availLeft: 75,
        // project-specific vars
        listSize: 6,
        listSmallSize: 4
    }
};
